import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  RaisedButton,
  FlatButton,
  Stepper,
  Step,
  StepLabel, FontIcon,
} from 'material-ui';
import R from 'ramda';
import UploadFiles from './upload-files';
import SelectRequests from './select-requests';
import injectStyleSheet from 'react-jss';
import MessageBox from '../../../contracting/generic-components/message-box';
import LoadingOverlay from '../../../tc-ui/loading-overlay';

const propTypes = {
  signupFn: PropTypes.func,
  classes: PropTypes.object,
  updateDialogProps: PropTypes.func,
  allRequests: PropTypes.array,
  files: PropTypes.array,
  sendRates: PropTypes.func,
  sendingRates: PropTypes.bool,
  ratesSent: PropTypes.bool,
};

const styles = {
  stepContent: { padding: '16px 32px', paddingTop: 0 },
  dropZone2: {
    display: 'flex',
    border: '4px dashed rgb(239, 239, 239) !important',
    padding: '8px',
    clear: 'both',
    minHeight: '100px',
    alignItems: 'center',
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.44)',
  },
  centerText: {
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
  },
};

class SendRatesFileWizardContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 1,
    };
  }
  componentWillMount() {

  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  onCheckRequest = obj => (_, checked) => {
    const {
      updateDialogProps,
      allRequests = [],
    } = this.props;
    const duplicateRequest = checked &&
      allRequests.some(request => request.checked
        && (obj.startDate !== request.startDate
          || obj.endDate !== request.endDate)
      );
    if (duplicateRequest) {
      this.setState({ error: 'You can only select requests with the same contracting period.' });
    } else {
      this.setState({ error: '' });
      updateDialogProps({
        allRequests: allRequests.map(request => {
          if (request._id === obj._id) return R.assoc('checked', checked, request);
          return request;
        }),
      });
    }
  };

  updateFileList = (files) => {
    this.setState({ error: '' });
    this.props.updateDialogProps({ files });
  };

  removeFile = i => () => {
    this.props.updateDialogProps({ files: R.remove(i, 1, this.props.files) });
  };
  goPrev = () => this.setState({ activeStep: this.state.activeStep - 1 });

  goNext = () => {
    const {
      activeStep,
    } = this.state;
    const {
      files = [],
      allRequests = [],
    } = this.props;
    if (activeStep === 1) {
      if (!files.length) {
        this.setState({ error: 'Please upload at least one file.' });
      } else {
        this.setState({ activeStep: 2 });
      }
    }

    if (activeStep === 2) {
      const selectedRequests = allRequests.filter(obj => obj.checked);
      if (!selectedRequests.length) {
        this.setState({ error: 'Please select at least one request.' });
      } else {
        this.setState({ activeStep: 3, error: '' });
      }
    }
  };

  sendRates = () => {
    const {
      subject,
      message,
    } = this.state;
    if (!(subject && message)) {
      this.setState({ error: 'Please add a subject and message.' });
    } else {
      const { sendRates } = this.props;
      sendRates({ subject, message });
    }
  };

  render() {
    const {
      sendingRates,
      ratesSent,
      classes: css,
      files = [],
      allRequests = [],
    } = this.props;
    const { activeStep, error, subject, message } = this.state;
    const steps = ['Upload Rates Files', 'Select Buyers', 'Customized Message'];
    if (ratesSent) {
      return (
        <div className={css.centerText}>
          <div style={{ marginTop: '24px', textAlign: 'center' }}>
            <FontIcon className="tc-icon-paperplane" color="#00bcd4" style={{ fontSize: '128px' }} />
            <br/>
            <br/>
            {`Your rates have been delivered to your buyers.\n
            `}
          </div>
        </div>
      );
    }
    return (
      <div>
        <Stepper activeStep={activeStep - 1}>
          {
            steps.map(step => (
              <Step key={step}>
                <StepLabel>{step}</StepLabel>
              </Step>
            ))
          }
        </Stepper>
        <div className={css.stepContent}>
          {(() => {
            if (activeStep === 1) {
              return (
                <UploadFiles
                  files={files}
                  css={css}
                  removeFile={this.removeFile}
                  updateFileList={this.updateFileList}
                />
              );
            }
            if (activeStep === 2) {
              return (
                <SelectRequests
                  requests={allRequests}
                  onCheckRequest={this.onCheckRequest}
                />
              );
            }
            if (activeStep === 3) {
              return (
                <div style={{ paddingLeft: '16px' }}>
                  <label style={{ fontSize: '14px' }}>Subject:</label>
                  <br/>
                  <input
                    value={subject}
                    autoFocus
                    onChange={({ target: { value } }) => this.setState({ subject: value })}
                    style={{ width: '100%', height: '32px' }}
                  />
                  <div style={{ fontSize: '14px', margin: '12px 8px 24px 0', color: '#616161' }}>
                    <label>Custom Message: </label>
                    <br/>
                    <MessageBox
                      value={message || ''}
                      onChange={(value) => this.setState({ message: value })}
                    />
                    <br/>
                  </div>
                </div>
              );
            }
          })()}
        </div>
        <div className="flex-tc-sb">
          {
            activeStep > 1 ? (
              <FlatButton
                secondary
                label="Previous"
                onTouchTap={this.goPrev}
              />
            ) : <div/>
          }
          <div style={{ color: 'red' }}>
            {error}
          </div>
          {
            (() => {
              const disabled = (() => {
                if (activeStep === 1) {
                  return !files.length;
                }
                if (activeStep === 2) {
                  return !allRequests.filter(obj => obj.checked).length;
                }
                return sendingRates;
              })();
              if (activeStep < 3) {
                return (
                  <RaisedButton
                    secondary
                    disabled={disabled}
                    label="Next"
                    onTouchTap={this.goNext}
                  />
                );
              }
              return (
                <RaisedButton
                  labelStyle={{ color: '#fff' }}
                  primary
                  label="Send Rates"
                  disabled={disabled}
                  onTouchTap={this.sendRates}
                />
              );
            })()
          }
        </div>
        <LoadingOverlay loading={sendingRates} />
      </div>
    );
  }
}

const mapStateToProps = ({}) => ({

});

const mapDispatchToProps = dispatch => ({

});
SendRatesFileWizardContainer.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(injectStyleSheet(styles)(SendRatesFileWizardContainer));



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/dialog/wizards/send-rates-wizard-container.jsx